// Figma: no frame provided yet — built using the established design system (bordered
// card row, same pattern as ../CampaignInfo.js) per the "extrapolate" decision.
// LOGIC PORTED from LC2's EngagementInsights.js (commons/components/HomeTabs/Engagement/):
// same shape (array of {title, description, amount, color}), same "Top N%" chip. Renders
// nothing when the list is empty, same as LC2.
import React from 'react';
import {Box, Chip, Stack, Typography} from '@mui/material';
import {tokens} from '../../../themes/ThemeCustomization';

const EngagementInsights = ({insights = []}) => {
    if (!Array.isArray(insights) || insights.length === 0) return null;

    return (
        <Box sx={{border: `1px solid ${tokens.color.neutral200}`, borderRadius: '6px', backgroundColor: tokens.color.white, p: 2}}>
            <Stack spacing={0.5} sx={{mb: 2}}>
                <Typography variant="subtitle1" fontWeight={600}>
                    Insights
                </Typography>
                <Typography variant="body2" color="text.secondary">
                    Compare your residents to the Stake network.
                </Typography>
            </Stack>
            <Stack direction="row" spacing={1.5}>
                {insights.map((entry, index) => (
                    <Box
                        key={index}
                        sx={{flex: 1, border: `1px solid ${tokens.color.neutral200}`, borderRadius: '6px', p: 2}}
                    >
                        <Stack direction="row" justifyContent="space-between" spacing={1}>
                            <Stack spacing={0.5}>
                                <Typography variant="subtitle1" fontWeight={600}>
                                    {entry.title ?? ''}
                                </Typography>
                                <Typography variant="body2" color="text.secondary">
                                    {entry.description}
                                </Typography>
                            </Stack>
                            <Chip
                                size="small"
                                label={`Top ${entry.amount}%`}
                                sx={{backgroundColor: tokens.color.success50, color: tokens.color.success500, fontWeight: 500}}
                            />
                        </Stack>
                    </Box>
                ))}
            </Stack>
        </Box>
    );
};

export default EngagementInsights;
